import { Form, useNavigation } from "react-router";
import { RewardsProgram } from "~/entities/rewards/types";
import RewardsEnteredMessage from "./RewardsEnteredMessage";
import SubmitButton from "./SubmitButton";

type Props = {
  onContinue: () => void;
  isActive: boolean;
  rewardsProgram?: RewardsProgram | null;
};

const SurveyConfirmation: React.FC<Props> = ({
  onContinue,
  isActive,
  rewardsProgram,
}) => {
  const navigation = useNavigation();
  const isSubmitting = navigation.state === "submitting";

  if (!isActive) return null;
  return (
    <div className="flex flex-col gap-5 text-center">
      <h2 className="text-[20px] text-blue900 font-sans mt-[10px] uppercase font-bold">
        You&apos;ve done it!
      </h2>
      <img
        alt="Confirmation: Unlocked member benefits"
        className="w-10 h-10 mx-auto"
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO3N0cm9rZTojNzNhZTNiO3N0cm9rZS1saW5lY2FwOnNxdWFyZTtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6NHB4O308L3N0eWxlPjwvZGVmcz48dGl0bGU+Q2hlY2ttYXJrPC90aXRsZT48cG9seWxpbmUgY2xhc3M9ImEiIHBvaW50cz0iMy4xMyAxMC44NSA2LjQxIDE0LjYyIDE2Ljk4IDUuMjgiLz48L3N2Zz4="
      />
      <h3 className="text-[22px] text-blue900 font-sans mt-0 font-bold">
        You&apos;ve unlocked awesome member benefits.
        <br />
        Complete your member profile or get back to shopping.
      </h3>
      <Form
        method="post"
        action="/resources/create-account-wizard"
        className="w-full text-left mt-[10px]"
      >
        <input
          type="hidden"
          name="intent"
          value="finish_registration"
        />
        <SubmitButton
          disabled={isSubmitting}
          label="Go shop"
          clickedLabel="Finishing..."
        />
      </Form>
      <div className="w-full text-left mt-[10px]">
        <button
          className="h-8 text-lg rounded-md px-[15px] uppercase text-white bg-gradient-to-b from-black100 to-gray hover:from-gray hover:to-gray"
          type="button"
          onClick={onContinue}
          aria-label="Proceed to complete profile"
        >
          Complete profile
        </button>
      </div>
      {rewardsProgram && <RewardsEnteredMessage program={rewardsProgram} />}
    </div>
  );
};

export default SurveyConfirmation;
